<template>
  <!-- 彈窗廣告 -->
  <div v-if="$store.getters.adMessage !== null" class="popup-wrap" :class="{ active: $store.getters.adMessage !== null }">
    <div class="popup-box">
      <img v-if="$store.getters.adMessage && $store.getters.adMessage.img !== null" :src="$store.getters.adMessage.img" class="commercial_img" alt="" @click="handleImageClick">
      <a class="popup-close" @click="hideModal" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Commercial',
  data() {
    return {
      not_show_again: false
    }
  },
  computed: {
    adImage() {
      if (!this.$store.getters.adMessage) {
        return null
      }
      return this.$store.getters.adMessage.img
    }
  },
  watch: {
    adImage(newVal, oldVal) {
      if (newVal != null) {
        this.showModal()
      }
    }
  },
  methods: {
    showModal() {
      if (this.adImage) {
        this.$store.commit('SET_READ_ANNOUNCEMENT', false)
      }
    },
    hideModal() {
      this.$store.commit('SET_READ_ANNOUNCEMENT', true)

      const closeFunc = this.$store.getters.adMessage.closeFunc
      if (closeFunc !== undefined && typeof closeFunc === 'function') {
        closeFunc()
      }

      this.$store.commit('SET_AD_MESSAGE', null)
    },
    handleImageClick() {
      this.$store.commit('SET_READ_ANNOUNCEMENT', true)
      const url = this.$store.getters.adMessage.imgLink
      const open_method = this.$store.getters.adMessage.urlOpenType
      const func = this.$store.getters.adMessage.func
      let iframe

      switch (open_method) {
        case 'self':
          window.location.href = url
          break
        case 'new':
          window.open(url, '_blank')
          break
        case 'iframe':
          iframe = document.createElement('iframe')
          iframe.src = url
          iframe.style.width = '100%'
          iframe.style.height = '100%'
          document.body.appendChild(iframe)
          break
        default:
          console.log('Invalid open_method value')
      }
      if (func !== undefined && typeof func === 'function') {
        func()
      }
    }
  }
}
</script>

<style>
.popup-wrap .popup-box .commercial_img{
  border-radius: 10px;
  width: 100%;
	min-width: 260px;
	max-width: 356px;
  aspect-ratio: 89 / 150;
}
</style>
